import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { StatusBadge } from "@/components/StatusBadge";
import { ProfileLink } from "@/components/ProfileDrawer";
import { formatDateDDMMYYYY } from "@/lib/format";

export const Tours = () => {
  const [tours, setTours] = useState([]);
  const [sites, setSites] = useState([]);
  const [guards, setGuards] = useState([]);
  const [checkpoints, setCheckpoints] = useState([]);

  const load = useCallback(async () => {
    const [t, s, g, c] = await Promise.all([
      api.get("/tours"),
      api.get("/sites"),
      api.get("/guards"),
      api.get("/checkpoints"),
    ]);
    setTours(t.data);
    setSites(s.data);
    setGuards(g.data);
    setCheckpoints(c.data);
  }, []);

  useEffect(() => { load(); }, [load]);

  const siteName = (id) => sites.find(s => s.id === id)?.name || id;
  const guardName = (id) => guards.find(g => g.id === id)?.full_name || "—";

  return (
    <div className="grid lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2 s-card" style={{ padding: 0 }}>
        <div className="p-5 border-b" style={{ borderColor: "var(--border-dark)" }}>
          <div className="h-section">Tour history · last 200</div>
        </div>
        <table className="s-table">
          <thead><tr><th>Date</th><th>Guard</th><th>Site</th><th>Scanned</th><th>Status</th></tr></thead>
          <tbody>
            {tours.map(t => (
              <tr key={t.id} data-testid={`tour-row-${t.id}`}>
                <td className="mono">{formatDateDDMMYYYY(t.started_at)}</td>
                <td><ProfileLink kind="guard" id={t.guard_id}>{guardName(t.guard_id)}</ProfileLink></td>
                <td className="text-muted">{siteName(t.site_id)}</td>
                <td>
                  <span className="mono text-teal">{(t.scanned || []).length}</span>
                  <span className="text-muted mono">/{(t.checkpoint_ids || []).length}</span>
                </td>
                <td><StatusBadge status={t.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="s-card">
        <div className="h-section mb-3">Checkpoints by site</div>
        <div className="space-y-3">
          {sites.slice(0, 6).map(s => {
            const cps = checkpoints.filter(c => c.site_id === s.id);
            return (
              <div key={s.id}>
                <div style={{ fontSize: 13, color: "#fff" }}>{s.name}</div>
                <div className="flex flex-wrap gap-2 mt-2">
                  {cps.map(c => (
                    <span key={c.id} className="badge badge-neutral mono" style={{ fontSize: 11 }}>
                      {c.name} · {c.qr_code.slice(0, 8)}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
